/**
 * Whitelisted domains
 */
const WHITELISTED_DOMAINS = [
  'static.airasia.cn',
  'static.airasia.com',
  'static.stgairasia.com',
  'static.stgairasia.cn',
];

/**
 * Check if URL is external (not whitelisted)
 */
export const isExternalLink = (url: string): boolean => {
  if (!url) {
    return false;
  }

  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return false;
  }

  // Check if whitelisted
  const isWhitelisted = WHITELISTED_DOMAINS.some((domain) =>
    url.includes(domain),
  );

  return !isWhitelisted;
};

/**
 * Check if URL is resource file (CSS, JS, images, fonts, etc.)
 */
export const isResourceFile = (url: string): boolean => {
  const resourceExtensions =
    /\.(css|js|png|jpg|jpeg|gif|svg|ico|woff|woff2|ttf|eot)(\?.*)?$/i;
  return (
    resourceExtensions.test(url) ||
    url.includes('fonts.googleapis.com') ||
    url.includes('/css/') ||
    url.includes('/js/') ||
    url.includes('/images/')
  );
};
